<template>
  <div class="d-print-none">
    <b-container>

      <MainMenu/>

    </b-container>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Category from "./SideMenu/Category.vue";
import MainMenu from "./menus/MainMenu.vue";

export default {
  name: "Nav3",
  components: {Category, MainMenu},
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      storeMenus: 'Menu/getStoreMenus'
    }),
    getFilter() {
      return this.$store.getters['Product/getFilter']('category');
    },

  },
  methods: {},
  async mounted() {
    await this.$store.dispatch("Category/getCategories");
  },
};
</script>

<style scoped>


</style>